import Icon from '@components/common/Icon';
import { SOCIAL_LINKS } from '@lib/constants';

const SocialLinksSection = () => {
  const socialLinks = [
    {
      icon: 'github',
      label: 'GitHub',
      href: SOCIAL_LINKS.github,
      description: 'Follow my projects',
    },
    {
      icon: 'linkedin',
      label: 'LinkedIn',
      href: SOCIAL_LINKS.linkedin,
      description: 'Connect professionally',
      disabled: SOCIAL_LINKS.linkedin === '#',
    },
    {
      icon: 'lichess',
      label: 'Lichess',
      href: SOCIAL_LINKS.lichess,
      description: 'Challenge me to chess',
      disabled: SOCIAL_LINKS.lichess === '#',
    },
  ];

  return (
    <section
      className="py-16 px-6"
      style={{ backgroundColor: 'var(--color-theme-1)' }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2
          className="text-3xl md:text-4xl font-bold mb-4"
          style={{ color: 'var(--color-heading)' }}
        >
          Connect on Social Media
        </h2>
        <p
          className="text-lg mb-12"
          style={{ color: 'var(--color-subheading)' }}
        >
          Stay updated with my latest projects and achievements
        </p>

        <div className="flex flex-wrap justify-center gap-6">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.disabled ? undefined : social.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`group p-8 rounded-2xl border-2 transition-all duration-300 ${
                social.disabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:scale-110 hover:shadow-xl'
              }`}
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: social.disabled
                  ? 'var(--color-border-light)'
                  : 'var(--color-card-border)',
              }}
              onClick={(e) => {
                if (social.disabled) {
                  e.preventDefault();
                }
              }}
            >
              <div className="flex flex-col items-center gap-3">
                <Icon
                  name={social.icon}
                  size="2xl"
                  className="transition-transform duration-300 group-hover:scale-110"
                  style={{ color: 'var(--color-accent-6)' }}
                />
                <div>
                  <h3
                    className="text-xl font-semibold mb-1"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    {social.label}
                  </h3>
                  <p
                    className="text-sm"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    {social.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialLinksSection;
